/* eslint-disable prettier/prettier */
import styled, { css } from 'styled-components';

interface StatusProps {
  status?: 'I' | 'A';
}
const StatusVariations = {
  I: css`
    color: var(--purple);
    background: var(--gray-line);
  `,
  A: css`
    background: var(--green);
  `,
};

export const Container = styled.div`
  form {
    label {
      background: #ffffff;
    }
  }
  .btn-wrapper {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: 10px;
    button {
      height: 40px;
      width: inherit;
    }

    .btn-cancelar {
      height: 40px;
      width: inherit;
      margin-right: 3px;
      color: var(--black);
      background-color: transparent;
      border: 2px solid;

      &:hover {
        color: var(--white);
        background-color: var(--orange);
      }
    }
  }

  .btn-modal {
    margin-top: 30px;
  }

  .titleWrapper {
    height: 117px;
  }

  .importForm {
    p {
      font-size: 18px;
      line-height: 24px;
      color: #2a2a2a;
      font-weight: 400;
      word-wrap: break-word;
      word-break: break-word;
    }
  }
  .erro {
    width: 101%;
    margin-top: 15px;
    overflow-y: scroll;
    max-height: 200px;
    ::-webkit-scrollbar-track {
      background: transparent;
    }
    ::-webkit-scrollbar {
      background-color: transparent;
      width: 12px;
      height: 10px;
    }
    ::-webkit-scrollbar-thumb {
      background-color: #949494;
      height: 50px;
      border-radius: 10px;
    }
  }
  .errosLength {
    position: absolute;
    margin-top: -30px;
  }
  .descriptionErro {
    background: #ff00008f;
    color: var(--white);
    padding: 10px;
    font-size: 1.15rem;
    border-radius: 5px;
    margin-bottom: 5px;
    margin-right: 5px;
  }

  .TitleContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: 29px;
    @media only screen and (max-width: 930px) {
      flex-direction: column;
      justify-content: center;
      align-self: center;
      display: grid;
    }
    @media only screen and (max-width: 767px) {
      margin-top: -50px;
    }
  }

  .link {
    color: var(--purple) !important;
    text-decoration: underline;
  }
  .file-picker {
    width: 200px;
    margin-top: 20px;
    margin-left: auto;
  }
`;

export const Title = styled.h1`
  font-family: Roboto Slab;
  font-style: normal;
  font-weight: bold;
  font-size: 45px;
  line-height: 59px;

  color: var(--orange);

  align-items: center;
  justify-content: space-between;
`;

export const ButtonsContainer = styled.h1`
  .buttonsInitial {
    margin-top: 16px;
    display: flex;
    button {
      font-size: 0.9rem;
      border-radius: 17px 17px;
      display: flex;
      align-items: center;
      margin-right: 10px;
      transition: background 0.3s ease;
      @media only screen and (max-width: 930px) {
        margin-top: 10px;
      }
    }
    .associar {
      width: 190px;
      align-self: center;
      justify-content: center;
      color: var(--orange);
      border: 2px solid var(--orange);
      background-color: transparent;
      &:hover {
        background: var(--orange);
        color: var(--white);
      }
    }
    .importar {
      align-self: center;
      justify-content: center;
      &:hover {
        background: #b14729;
      }
    }

    @media only screen and (max-width: 930px) {
      flex-direction: column;
      justify-content: center;
      align-self: center;
      display: grid;
    }
  }

  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    background-color: var(--orange);
    border: 2px solid var(--orange);
    border-radius: 17px 17px;
    font-size: 0.9rem;
    font-weight: 400;
    margin-right: 10px;
    padding: 8px 0;
    width: 190px;
    font: 400 0.9rem 'Source Sans Pro', sans-serif;
    &:hover {
      background: #b14729;
      border: 2px solid #b14729;
    }
  }

  .icon {
    margin-top: 5px;
    margin-right: 5px;
  }
`;

export const StatusRow = styled.div<StatusProps>`
  color: var(--white);
  width: 100%;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;

  ${props => StatusVariations[props.status || 'I']}
`;

export const FiltersContainer = styled.div`
  margin-top: 32px;
  display: flex;
  align-items: flex-start;

  @media only screen and (max-width: 1225px) {
    flex-direction: column;
  }

  .filter {
    margin-right: 5px;
    @media only screen and (max-width: 1225px) {
      margin-bottom: 10px;
    }
    button {
      font-size: 0.9rem;
      display: flex;
      align-items: center;
      transition: background 0.3s ease;
      color: black;

      &:hover {
        background: #9ea1a2;
      }
    }
  }

  .search {
    width: 100%;
    height: 40px;
    @media only screen and (max-width: 1225px) {
      margin-bottom: 10px;
    }
    form {
      position: relative;
      height: 20px;
    }
    div {
      margin-top: -4px;
      input {
        font-size: 18px;
      }
    }
    .select {
      margin-top: 6px;
      margin-right: 50px;
      font-size: 18px;
      width: 170px;
      position: relative;
      div {
        margin-top: -2px;
      }
      z-index: 2;
    }

    .searchButton {
      position: absolute;
      right: 0px;
      top: 0;
      display: flex;
      align-items: center;
      transition: background 0.3s ease;

      &:hover: {
        background: red;
      }
    }
  }
  .buttonsContainer {
    display: flex;
    @media only screen and (max-width: 930px) {
      margin-left: 0px;
    }
    button {
      width: 120px;
      font-size: 0.9rem;
      border-radius: 17px 17px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 10px;
      transition: background 0.3s ease;
    }
    .clearFilters {
      width: 145px;
      border-radius: 5px;
      margin-left: 5px;
      font-size: 0.9rem;
      display: flex;
      align-items: center;
      transition: background 0.3s ease;
      color: black;
      background-color: var(--aside-background);

      &:hover {
        background: #9ea1a2;
      }
      @media only screen and (max-width: 1225px) {
        margin-left: 0px;
      }
    }
    .csv {
      color: var(--white);
      border: 2px solid var(--purple);
      &:hover {
        background: var(--white);
        color: var(--purple);
      }
    }
    .pdf {
      color: var(--white);
      border: 2px solid var(--purple);
      &:hover {
        background: var(--white);
        color: var(--purple);
      }
    }
  }

  @media only screen and (max-width: 930px) {
    margin-top: 100px;
    flex-direction: column;
  }
  @media only screen and (max-width: 767px) {
    margin-top: 200px;
  }
`;

export const CardSection = styled.div`
  cursor: pointer;
  color: var(--orange);
`;

export const Acoes = styled.div`
  display: flex;
  div {
    padding-top: 5px;
    background-color: transparent;
    height: 35px;
    width: 35px;
    display: flex;
    align-content: center;
    justify-content: center;
  }

  .clickable {
    cursor: pointer;
    background: transparent;
  }
`;

export const FlexRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  margin-top: 30px;

  .DadosFunc {
    text-align: center;
    h3 {
      color: var(--text);
      margin-right: 5px;
      font-weight: bold;
    }
    h4 {
      color: var(--purple);
      margin-left: 5px;
      padding-top: 2px;
    }
  }

  form {
    margin-top: -15px;
    margin-bottom: 10px;
  }

  .checkbox {
    display: none;
  }

  Button + Button {
    margin-left: 20px;
    @media only screen and (max-width: 523px) {
      margin-left: 0px;
    }
  }
  Button {
    margin-top: 30px
    height: 50px;
  }
  .btn {
    color: #757575;
    background-color: #fff;
    border: 1px solid #e8e8e8;
  }
  .btn-remover {
    color: #e6273d;
    background-color: #fff;
    border: 1px solid #e8e8e8;

    &:hover {
      color: var(--white);
      background-color: var(--orange);
    }
  }
  .btn-cancelar {
    height: 40px;
    width: inherit;
    margin-right: 3px;
    color: var(--orange);
    background-color: transparent;
    border: 2px solid var(--orange);

    &:hover {
      color: var(--white);
      background-color: var(--orange);
    }
  }

  .btn-enviar {
    height: 40px;
    margin-top: 0;
    width: inherit;
    color: var(--white);
    background-color: var(--orange);
    border: 2px solid var(--orange);

    &:hover {
      color: var(--orange);
      background-color: var(--white);
    }
  }
`;

export const ModalContent = styled.div`
  height: 250px;
  width: 600px;
  padding: 0px 15px 30px 15px;
  text-align: center;
  p {
    padding-bottom: 10px;
  }
`;

export const LinkModal = styled.a`
  text-decoration: underline;
  color: var(--purple) !important;
`;

export const FormWrapper = styled.div`
  width: 100%;
  Form {
    margin-top: 20px;
  }

  input {
    height: 40px;
  }
  .btn-wrapper {
    margin-top: 30px;
    display: flex;
    width: 100%;
    button {
      width: inherit;
    }

    .btn-cancelar {
      color: #757575;
      background-color: #fff;
      border: 1px solid #e8e8e8;
      margin-right: 20px;
    }
  }
`;
